import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/use-auth';

export function LogoutRoute() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    void signOut().finally(() => {
      navigate('/login', { replace: true });
    });
  }, [signOut, navigate]);
  return <Navigate to="/login" replace />;
}
